import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/shared/data.service';
import { UserService } from 'src/app/shared/user.service';
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit, OnDestroy {
  @ViewChild('f', {static: false}) feedbackForm: NgForm;

  UserEmail: string;
  userChanged: Subscription;
  feedback: string;
  constructor(private dataService: DataService, private userService: UserService) { }

  ngOnInit() {
    this.userChanged = this.userService.userChanged.subscribe(
      (user) => {
        this.UserEmail = user.UserEmail;
      }
    )
  }
  ngOnDestroy() {
    this.userChanged.unsubscribe();
  }
  onSubmit() {
    this.dataService.sendFeedbackEmail(this.feedbackForm.value.feedback).subscribe(
      (response) => {
        if (response.toUpperCase() == "OK"){
          this.feedback = "";
          $('#feedbackModal').modal('hide');
        }
      }
    )
  }
}

